import React from 'react';

import ChatSettingsPane from 'llm/chat-library/shared/list-detail/ChatSettingsPane';
import {AISettingsGeneralBody} from 'llm/chat-library/sidepanel/AISettingsGeneral';

export default function ChatSettingsGeneralContent({
  onRestartOnboarding,
}: {
  /** Restarts onboarding from settings; closes the modal (wired by the parent). */
  onRestartOnboarding?: () => void;
}): JSX.Element {
  return (
    <ChatSettingsPane header={{title: 'General'}}>
      <AISettingsGeneralBody onRestartOnboarding={onRestartOnboarding} />
    </ChatSettingsPane>
  );
}
